import {useAction} from '../../actions'
import {useStatusContext} from '../../contexts/StatusContext'
import {useFormUserEventHandler} from '../../lib/metrika'
import type {ActionButtonWidgetProps as Props} from '../types'

export function useActionButtonProps({config}: Props) {
  const {button_size, loading_style, normal_style, action, metrica_label, widget_id} = config
  const {isFetching} = useStatusContext()
  const style = isFetching ? loading_style : normal_style
  const {ActionComponent: actionElement, triggerAction} = useAction(action ? {...action, widget_id} : void 0)
  const handleReachGoal = useFormUserEventHandler()

  function handlePress() {
    metrica_label && handleReachGoal(metrica_label)
    triggerAction?.()
  }

  return {
    size: button_size,
    loading: isFetching,
    handlePress: isFetching ? undefined : handlePress,
    style,
    actionElement,
  } as const
}
